import { useIsFetching } from "@tanstack/react-query"

import { NETWORKS_ROOT_QUERY_KEY } from "./queryKeys"

export function useIsFetchingNetwork() {
    const isFetchingReferential = useIsFetching({ queryKey: [NETWORKS_ROOT_QUERY_KEY, "referential"] })
    const isFetchingFeatures = useIsFetching({ queryKey: [NETWORKS_ROOT_QUERY_KEY, "features"] })

    const isFetching = isFetchingReferential
        || isFetchingFeatures
    return isFetching > 0
}